var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportsNavIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7292_2248)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7292_2248",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 -3.8147e-06H26V26H0V-3.8147e-06Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7292_2248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1406 25.2383H3.85938V0.761715H22.1406V25.2383Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5703 11.4766C17.5703 14.0007 15.5241 16.0469 13 16.0469C10.4759 16.0469 8.42969 14.0007 8.42969 11.4766C8.42969 8.95243 10.4759 6.90625 13 6.90625C15.5241 6.90625 17.5703 8.95243 17.5703 11.4766Z",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 6.90625V11.4766H17.5703",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 11.4766L9.95312 14.5234",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5703 0.761718V3.80859H8.42969V0.761718",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14453 19.1445H9.19141",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.14453 22.1914H15.2852",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8086 22.1914H19.8555",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7148 19.1445H19.8555",
    stroke: "black",
    strokeWidth: 1.3,
    strokeMiterlimit: 10
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7292_2248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsNavIcon);
export default __webpack_public_path__ + "static/media/reportsNavIcon.1f2bef1223d3d15860a796a392bc1782.svg";
export { ForwardRef as ReactComponent };